if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.form.querySelector("[name=id]")) {
          this.form.querySelector("[name=id]").disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer") && this.submitButton)
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Check current cart count before adding
        let initialCartCount = 0;
        const cartCounts = document.querySelectorAll('.cart-count, .cart-count-bubble');
        cartCounts.forEach(el => {
          const val = parseInt(el.textContent.replace(/\D/g, '')) || 0;
          if (val > initialCartCount) initialCartCount = val;
        });

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          if (this.submitButton.id != "ProductSubmitButton-product-quickview") {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              console.log('[ProductForm] No cart element found, redirecting');
              window.location = window.routes.cart_url;
              return;
            }

            console.log('[ProductForm] Item added successfully', response);
            console.log('[ProductForm] Cart element:', this.cart);
            console.log('[ProductForm] Has renderContents method:', typeof this.cart.renderContents);

            if (!this.error && typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }
            this.error = false;
            const is_cart_page =
              document.body.classList.contains("template-cart");

            console.log('[ProductForm] Is cart page:', is_cart_page);

            if (!is_cart_page) {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                console.log('[ProductForm] Calling renderContents with response:', response);
                try {
                  // Initial render with immediate data
                  this.cart.renderContents(response);
                  console.log('[ProductForm] renderContents called successfully');
                  
                  // Show loading state for discount calculation
                  this.cart.classList.add('loading', 'start');
                  
                  // Background refresh for correct discounts (same as updateQuantity)
                  setTimeout(() => {
                    fetch(`${routes.cart_update_url}`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({ attributes: { '_discount_refresh': Date.now() } })
                    })
                    .then(() => {
                      return fetch(`${routes.cart_update_url}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({
                          sections: this.cart.getSectionsToRender().map((section) => section.id),
                          sections_url: window.location.pathname
                        })
                      });
                    })
                    .then(res => res.json())
                    .then(parsedState => {
                      console.log('[ProductForm] Background discount refresh complete');
                      this.cart.renderContents(parsedState);
                      
                      // Hide loading and show finished state
                      this.cart.classList.remove('loading', 'start');
                      this.cart.classList.add('loaded', 'finished');
                      setTimeout(() => {
                        this.cart.classList.remove('loaded', 'finished');
                      }, 1000);
                      
                      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                          source: "product-form-refresh",
                          cartData: parsedState
                        });
                      }
                    })
                    .catch(err => {
                      console.error('[ProductForm] Background refresh failed:', err);
                      // Remove loading state on error
                      this.cart.classList.remove('loading', 'start');
                    });
                  }, 1000);
                } catch (error) {
                  console.error('[ProductForm] Error calling renderContents:', error);
                }
              } else {
                console.error('[ProductForm] Cannot call renderContents - cart:', this.cart, 'method exists:', typeof this.cart?.renderContents);
              }
            } else {
              closePopup.hide();
            }
            const shopableModal = document.querySelector("shopable-modal");
            if (shopableModal) {
              shopableModal.classList.remove("show");
              setTimeout(() => {
                shopableModal.remove();
                document.body.classList.remove("modal-open");
              }, 300);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// Cart polling to ensure UI updates even when other scripts add items
if (typeof window.cartPolling === 'undefined') {
  window.cartPolling = {
    lastCount: -1, // Start with -1 to ensure first check triggers update
    lastCartToken: '',
    isUpdating: false,
    updateTimeout: null,
    pauseTimeout: null,

    // Pause polling temporarily (for bundle apps that do multiple operations)
    pause(duration = 3000) {
      this.isUpdating = true;
      clearTimeout(this.pauseTimeout);
      this.pauseTimeout = setTimeout(() => {
        this.isUpdating = false;
        // Force an immediate check after pause ends
        this.checkCart(true);
      }, duration);
    },

    checkCart(force = false) {
      // Skip if currently updating or paused (unless forced)
      if (this.isUpdating && !force) return;

      fetch('/cart.js?_=' + Date.now(), {
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache'
        }
      })
        .then(r => r.json())
        .then(cart => {
          // Compare both item count AND cart token for accurate change detection
          const cartChanged = cart.item_count !== this.lastCount || cart.token !== this.lastCartToken;

          if (cartChanged) {
            this.lastCount = cart.item_count;
            this.lastCartToken = cart.token;

            // Clear any pending update
            clearTimeout(this.updateTimeout);

            // Update immediately
            this.updateUI(cart);
          }
        })
        .catch(() => { });
    },

    updateUI(cart) {
      // Update all cart count elements
      document.querySelectorAll('.cart-count').forEach(el => {
        // Find the span with aria-hidden="true" inside and update its text
        const countSpan = el.querySelector('span[aria-hidden="true"]');
        if (countSpan) {
          countSpan.textContent = cart.item_count;
        }
        // Update the visually-hidden span for screen readers
        const hiddenSpan = el.querySelector('.visually-hidden');
        if (hiddenSpan) {
          // Keep the translation text but update the count
          hiddenSpan.textContent = hiddenSpan.textContent.replace(/\d+/, cart.item_count);
        }
      });

      // Update is-empty class on cart drawer
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.toggle('is-empty', cart.item_count === 0);
      }

      // Trigger pubsub event if available
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'polling', cartData: cart });
      }
    },

    init() {
      // Initial check
      setTimeout(() => this.checkCart(true), 500);

      // Check cart every 1500ms for changes
      setInterval(() => this.checkCart(), 1500);

      // Also listen for cart AJAX requests from other scripts
      this.interceptCartRequests();
    },

    interceptCartRequests() {
      // Intercept fetch requests to cart endpoints
      const originalFetch = window.fetch;
      window.fetch = (...args) => {
        const url = args[0];
        const urlStr = typeof url === 'string' ? url : url.url || '';

        // Check if this is a cart modification request
        if (urlStr.includes('/cart/add') || urlStr.includes('/cart/change') || urlStr.includes('/cart/update') || urlStr.includes('/cart/clear')) {
          // Pause polling during cart operation
          this.pause(2000);
        }

        return originalFetch.apply(window, args);
      };

      // Also intercept XMLHttpRequest for older scripts
      const originalXHROpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
          window.cartPolling.pause(2000);
        }
        return originalXHROpen.apply(this, [method, url, ...rest]);
      };
    }
  };

  // Start polling after page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.cartPolling.init());
  } else {
    window.cartPolling.init();
  }

  // Expose pause function globally for bundle apps to use
  window.pauseCartPolling = (duration) => window.cartPolling.pause(duration);
}
